<template>
<div class="flex w-full vx-row no-gutter justify-center">
  <div class="vx-col sm:w-full md:w-full lg:w-3/5">
    <!-- <start-study v-show="!isStart" v-bind:studyInfo="studyInfo" @onStart="onStart"/> -->
    <vx-card class="study-card">
      <vs-list>
        <vs-list-header title="음가를 잘 듣고 단어 속 음가에 유의해 들어보세요." icon-pack="feather" icon="icon-info"></vs-list-header>
        <vs-list-item class="msg-grp-container">
          <vs-chip color="warning mr-0">{{ contentIndex + 1 }} / {{contentsLen}}</vs-chip>
        </vs-list-item>
      </vs-list>
      
      <div class="vx-row">
        <div class="vx-col sm:w-1/2 md:w-1/2 w-full mb-4">
          <vx-card class="phonics-card flex items-center justify-center"> 
            <div><h2 class="text-primary sentence">{{ this.alphabetContent.sentence }}</h2></div>
          </vx-card>
        </div>
        <div class="vx-col sm:w-1/2 md:w-1/2 w-full mb-4">
            <vx-card class="phonics-card flex items-center justify-center">
              <div v-if="hideImage">
                <div class="mb-4"><h2 class="text-primary sentence text-center">{{ content.sentence }}</h2></div>
                <div><h2 class="text-primary sentence text-center">{{ content.translation }}</h2></div>
              </div>
              <div v-else><img :src="content.image" class="responsive card-img-top"></div>
            </vx-card>
        </div>
      </div>
      <div class="text-center mt-6 hidden">
        <audio ref="audioPlayer1" 
          controls 
          v-on:ended="audio1Finish" 
          controlsList="nodownload">Your browser does not support the <code>audio</code> element.
        </audio>

        <audio ref="audioPlayer2" 
          controls 
          v-on:ended="audio2Finish" 
          controlsList="nodownload">Your browser does not support the <code>audio</code> element.
        </audio>

      </div>  
    </vx-card>
    <top-button-bar @onReload="onReload" @onNext="onNext" @onFinish="onFinish" ></top-button-bar>
  </div>  
</div>
</template>

<script>

const NEXT_WORD_INTERVAL = 1000
const REPEAT_WORD_INTERVAL = 500

import StudyMenuMixin from './StudyMenuMixin'
import TopButtonBar      from './TopButtonBar.vue'

export default {
  mixins: [StudyMenuMixin],
  components: {
    TopButtonBar
  },
  data () {
    return {
      alphabetContent: {},
      contentList: [],
      contentsLen: 0,
      contentIndex: 0,
      hideImage: false,
      repeat: 0
    }
  },
  watch: {
    
  },
  computed: {

    audioPlayer1 () {
      return this.$refs.audioPlayer1
    },
    audioPlayer2 () {
      return this.$refs.audioPlayer2
    },
    content () {
      return this.contentList[this.contentIndex]
    }
  },
  methods: {
    onReload () {
      this.audioPlayer1.pause()
      this.audioPlayer2.pause()
      this.contentIndex = 0
      this.startAlert()
    },
    onStart () {
      this.playAudio(this.audioPlayer1, this.alphabetContent.audio)
    },
    acceptAlert () {
      this.onStart()
    },
    playAudio (audioPlayer, src) {

      if (this.studyFinished) return

      audioPlayer.src = src
      audioPlayer.play()
    },
    audio1Finish () {
      if (this.repeat === 0) {
        this.repeat++
        setTimeout(function () {
          this.playAudio(this.audioPlayer1, this.alphabetContent.audio)
        }.bind(this), REPEAT_WORD_INTERVAL)
      } else {
        setTimeout(function () {
          this.repeat = 0
          this.hideImage = true
          this.playAudio(this.audioPlayer2, this.content.audio)
        }.bind(this), NEXT_WORD_INTERVAL)
      }
    },
    audio2Finish () {
      if (this.repeat === 0) {
        this.repeat++
        setTimeout(function () {
          this.playAudio(this.audioPlayer2, this.content.audio)
        }.bind(this), REPEAT_WORD_INTERVAL)
      } else if (this.contentIndex < (this.contentsLen - 1)) {
        setTimeout(function () {
          this.hideImage = false
          this.repeat = 0
          this.contentIndex++
          this.playAudio(this.audioPlayer1, this.alphabetContent.audio)
        }.bind(this), NEXT_WORD_INTERVAL)
      } else {
        this.onComplete()
      }
    },
    startAlert () {
      this.startStudyDlg('음가를 잘 듣고 단어 속 음가에 유의해 들어보세요.')
    }
  },
  created () {
    
    const contentJson = JSON.parse(this.sourceContent.contentBody)
    this.alphabetContent.sentence = contentJson.sentence[0]
    this.alphabetContent.audio = this.$buildAudioPath(this.sourceContent.contentCode, 1).replace('AP1', 'AP2')

    // 1번엔 대표 발음이 들어 있음. 단어의 발음은 2부터 이미지는 1부터
    for (let i = 1; i < contentJson.sentence.length; i++) {
      const content = {
        sentence: contentJson.sentence[i],
        translation: contentJson.translation[i],
        audio: this.$buildAudioPath(this.sourceContent.contentCode, i + 1).replace('AP1', 'AP2'),
        image: this.$buildImagePath(this.sourceContent.contentCode, i).replace('AP1', 'AP2')
      } 
      this.contentList.push(content)
    }
    
    this.contentsLen = this.contentList.length
    this.startAlert()
  },
  mounted () {
    
  },
  beforeDestroy () { 
    this.audioPlayer1.pause()
    this.audioPlayer2.pause()
  }

}

</script>

<style scoped>
.image-card {
  height: 360px
}
.image-box {
    
    height: 360px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.image-box img {
    max-width: 100%;
    max-height: 100%;
}
</style>
